import React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { useStyles } from './styles'
import RouterLinkButton from 'components/router-link-button'

const ConfirmOverwriteAvailabilityDialog = ({
  trigger,
  startDateTime,
  currentUrl,
}) => {
  const classes = useStyles()

  return (
    <Dialog trigger={trigger} maxWidth="xs">
      {({ closeDialog }) => {
        return (
          <>
            <DialogTitle>Overwrite blocked time?</DialogTitle>
            <DialogContent>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                Are you sure you want to book time over this block?
              </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button color="primary" onClick={closeDialog}>
                Cancel
              </Button>
              <RouterLinkButton
                color="primary"
                variant="contained"
                to={`${currentUrl}&startDateTime=${startDateTime}`}
              >
                Overwrite
              </RouterLinkButton>
            </DialogActions>
          </>
        )
      }}
    </Dialog>
  )
}

export default ConfirmOverwriteAvailabilityDialog
